import React from 'react';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { Box } from '@mui/material';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Contact from './pages/Contact';
import Gallery from './pages/Gallery';
import Advantages from './pages/Advantages'; // Import the Advantages page
import FadeInSection from './components/FadeInSection';
import './App.css';

// Custom theme with typography settings
const theme = createTheme({
  palette: {
    primary: {
      main: '#7e57c2', // Soft Deep Purple
      light: '#b085f5',
      dark: '#4d2c91',
    },
    secondary: {
      main: '#f06292', // Pastel Pink Accent
    },
    background: {
      default: '#fdfbfd', // Very light lavender tint
      paper: '#ffffff',
    },
    text: {
      primary: '#333333',
      secondary: '#666666',
    }
  },
  typography: {
    fontFamily: '"Poppins", "Roboto", "Arial", sans-serif',
    h3: { fontWeight: 700, letterSpacing: '0.5px' },
    h4: { fontWeight: 600, letterSpacing: '0.5px' },
    h5: { fontWeight: 600 },
    h6: { fontWeight: 600, letterSpacing: '0.2px' },
    button: { textTransform: 'none', borderRadius: '50px', letterSpacing: '0.5px' },
  },
  shape: {
    borderRadius: 16, // Rounded components
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 50, // Pill shape
          boxShadow: '0 4px 10px rgba(126, 87, 194, 0.2)',
          transition: 'all 0.3s ease',
          '&:hover': {
            transform: 'translateY(-2px)',
            boxShadow: '0 6px 15px rgba(126, 87, 194, 0.3)',
          }
        }
      }
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: 'none'
        }
      }
    }
  },
});



function App() {
  return (
    <ThemeProvider theme={theme}>
      <Router>
        <ScrollToTop />
        <Header />
        <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
          <Box sx={{ flexGrow: 1 }}>
            <Routes>
              <Route path="/" element={
                <FadeInSection>
                  <Home />
                </FadeInSection>
              } />
              <Route path="/about" element={
                <FadeInSection>
                  <About />
                </FadeInSection>
              } />
              <Route path="/services" element={
                <FadeInSection>
                  <Services />
                </FadeInSection>
              } />
              <Route path="/advantages" element={
                <FadeInSection>
                  <Advantages />
                </FadeInSection>
              } />
              <Route path="/contact" element={
                <FadeInSection>
                  <Contact />
                </FadeInSection>
              } />
              <Route path="/gallery" element={
                <FadeInSection>
                  <Gallery />
                </FadeInSection>
              } />
            </Routes>
          </Box>
          <Footer />
        </Box>
      </Router>
    </ThemeProvider>
  );
}

export default App;
